import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ReactECharts from "echarts-for-react";
import { getRegionalanalyseResult } from "../../selectors/widget.js";
import Block from "../Block";
import { round } from "lodash";
import { useCityIndexes } from "../../hooks/useProcessedCityIndexes.js";

const Graph = ({ module, regionIds }) => {
  const { name, dataset, cityIndexes } = module;
  const apiResult = useSelector((state) => getRegionalanalyseResult(state, dataset));
  const [mergedOptions, setMergedOptions] = useState(null);
  const [apiDataset, setApiDataset] = useState(null);
  const cityIndexArray = useCityIndexes(cityIndexes);

  useEffect(() => {
    if (apiResult) {
      let result = apiResult;
      let ids = regionIds.map((item) => item.nr);
      let filtered = result.response.filter((item) => ids.includes(item.nr));
      setApiDataset(filtered);
    }
  }, [apiResult, regionIds, name]);

  useEffect(() => {
    if (apiDataset) {
      let data = apiDataset;
      let series = [
        { label: "Kvinner", value: "k", index: cityIndexArray },
        { label: "Menn", value: "m", index: cityIndexArray },
        { label: "Norge", value: "k", index: [0] },
        { label: "Norge", value: "m", index: [0] },
      ];
      let labels = [...new Set(data.map((item) => item.alder))].sort((a, b) => (a > b ? 1 : -1));
      let cityIndexData = data
        .filter((item) => cityIndexArray.includes(item.nr) || item.nr === 0)
        .sort((a, b) => (a.alder > b.alder ? 1 : -1));

      let seriesData = series.map((item) => {
        let filtered = cityIndexData.filter((i) => item.index.includes(i.nr) && i.kjonn === item.value);
        if (item.label === "Norge") {
          return {
            name: item.label,
            type: "bar",
            barCategoryGap: "0%",
            stack: item.label === "background",
            barGap: "-100%",
            barWidth: "102%",
            itemStyle: {
              opacity: 0.5,
            },
            data: filtered.map((i) => {
              if (item.value === "k") {
                return round(i.folkemengde * -100, 2);
              }
              return round(i.folkemengde * 100, 2);
            }),
            tooltip: {
              show: item.label === false,
            },
            emphasis: { disabled: true },
          };
        }
        return {
          name: item.label,
          type: "bar",
          stack: item.label === "total",
          barCategoryGap: "0%",
          barWidth: "106%",
          itemStyle: {
            opacity: 0.8,
          },
          data: filtered.map((i) => {
            if (item.value === "k") {
              return round(i.folkemengde * -100, 2);
            }
            return round(i.folkemengde * 100, 2);
          }),
          zlevel: 2,
        };
      });

      let nObj = {
        ...JSON.parse(options),
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            let label = params[0].name;
            let tooltip = `Alder: ${label}</br>`;
            params.forEach((item) => {
              tooltip += `${item.marker} ${item.seriesName}: ${Math.abs(item.value)}% <br/>`;
            });
            return tooltip;
          },
        },
        legend: {},
        color: ["#f48fb1", "#5088ad", "#515151"],
        yAxis: {
          type: "category",
          data: labels,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        xAxis: {
          type: "value",
        },
        series: seriesData,
      };

      nObj.xAxis.axisLabel = {
        formatter: function (value) {
          return Math.abs(value) + "%";
        },
      };

      setMergedOptions(nObj);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiDataset, name]);

  if (!apiResult) return <p>Mangler data fra SSB</p>;

  if (mergedOptions) {
    return (
      <Block>
        <ReactECharts option={mergedOptions} style={{ marginTop: "20px", height: "600px" }} />
      </Block>
    );
  }

  return null;
};
export default Graph;

const options = JSON.stringify({
  grid: { top: 40, right: 20, bottom: 2, left: 40, containLabel: true },
  // xAxis: {
  //   type: 'category',
  //   data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  // },
  yAxis: {
    type: "value",
  },
  // series: [
  //   {
  //     data: [820, 932, 901, 934, 1290, 1330, 1320],
  //     type: 'line',
  //     smooth: true,
  //   },
  // ],
  tooltip: {
    trigger: "item",
    formatter: `{c}%`,
  },
});
